/**
 * Schiffe, deren Wiki-Daten für die reguläre Detailseiten-Darstellung nicht
 * ausreichen (z.B. abtrennbare Module, die als eigenes "Fahrzeug" geführt
 * werden, wie das Drake Command Module der Ironclad) und deshalb einen
 * manuellen Zuschnitt brauchen. Bewusst eine kleine, explizite Liste statt
 * einer generischen Heuristik — betrifft absehbar nur wenige Einzelfälle.
 *
 * Das Bild selbst wird serverseitig überschrieben (`MANUAL_IMAGE_OVERRIDES`
 * in `server/utils/gamedata.ts`) — hier nur die reine UI-Entscheidung, welche
 * Bereiche der Detailseite für dieses Schiff ausgeblendet werden (die
 * "Abmessungen"-Karte macht ohne echtes Referenzbild wenig Sinn).
 */
export const SHIP_IDS_WITHOUT_DIMENSIONS_CARD = new Set<string>(["drak-command-module"]);
